import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { CardsSection } from '../cardsSection';
import { cardsStore } from '../../store/cardsStore';
import { CARDS_TYPE, CUTTING_CARD } from '../../enums/cardTypes';
import { BurningCards } from '../burningCards';
import { ChipSection } from '../chipSection';
import { BET_TYPES, CHIPS_VIEW_TYPES } from '../../enums/cardOwner';
import WinPopup from '../winPopUp';
import { winningAmountStore } from '../../store/winningAmountStore';

export const FieldSection = observer(() => {
  const { isCuttingCardOpen } = cardsStore;
  const { burnedCards, selectedCardType } = cardsStore;
  const { currencyCode } = userInfoStore;
  const { winningAmount, winType } = winningAmountStore;
  const t = useTranslation();
  return (
    <div className='football-field'>
      {winType !== null && (
        <WinPopup
          winningAmount={winningAmount}
          t={t}
          currencyCode={currencyCode}
          winType={winType}
        />
      )}
      <div
        className={`football-field-inner ${
          // eslint-disable-next-line no-nested-ternary
          winType === BET_TYPES.home ? 'away' : winType === BET_TYPES.away ? 'home' : ''
        }`}
      >
        <div className={`cutting-card-holder ${isCuttingCardOpen ? 'show' : ''}`}>
          {/* add class "show" */}
          <div className={`cutting-card ${isCuttingCardOpen ? CARDS_TYPE[CUTTING_CARD] : ''}`} />
        </div>
        {burnedCards.length ? (
          <div className='burning-card-holder show'>
            <div
              className={`burning-card ${selectedCardType} ${CARDS_TYPE[burnedCards[0]?.card]}`}
            />
          </div>
        ) : null}
        <div className='football-field-chips-container'>
          {CHIPS_VIEW_TYPES.map(({ betType, betName, position, odd }) => (
            <div key={betType} className={`football-field-chip-block ${position}`}>
              <ChipSection betType={betType} />
              <span className='football-field-chip-count'>{odd}</span>
              <p className='football-field-name'>{t(betName)}</p>
            </div>
          ))}
        </div>
        <BurningCards />
        <CardsSection />
      </div>
    </div>
  );
});
